import { getCookie } from "typescript-cookie";

// typically used by loaders in hard refresh or cross-origin use cases
// ex. secureLoader
export function getLoginRedirect(request: Request) {
  const { pathname, search } = new URL(request.url);
  const params = new URLSearchParams();
  const fromParams = new URLSearchParams(search.slice(1)); //drop the question mark symbol

  // TODO there may be more SSO related params we want to send to /login
  // example, an SSO error
  if (fromParams.has("accountNotLinked")) {
    params.set("accountNotLinked", fromParams.get("accountNotLinked"));
    fromParams.delete("accountNotLinked");
  }
  if (fromParams.has("googleEmail")) {
    params.set("googleEmail", fromParams.get("googleEmail"));
    fromParams.delete("googleEmail");
  }

  params.set("to", `${pathname}?${fromParams.toString()}`);

  const savedOrigin = getCookie("SAVED_ORIGIN");
  if (savedOrigin) {
    params.set("from", savedOrigin);
  }

  return "/login?" + params.toString();
}
